// Central data — uses ONLY real assets from the original House & Home site and the Ariake brochure PDF.

export const SITE = {
  brand: "House & Home",
  tagline: "Inmobiliaria · 25 años construyendo hogares",
  phone: "+593 99 488 3058",
  phoneIntl: "593994883058",
  whatsapp: "+593 99 488 3058",
  whatsappIntl: "593994883058",
  email: "ventas@househome-inmobiliaria.com",
  city: "Tumbaco, Pichincha — Ecuador",
  agent: "Ing. Carlos Vergara",
  socials: {
    instagram: "https://instagram.com/househome_inmobiliaria",
    facebook: "https://www.facebook.com/Househome-Inmobiliaria-105825934432528/",
  },
  backedBy: "Constructora CVJ",
  commercialization: "Savana Bienes Raíces",
  brochureUrl: "/brochure-ariake.pdf",
  castillaBrochureUrl: "https://www.househome-inmobiliaria.com/_files/ugd/3913ec_75f368364753460fa59132b993c25565.pdf",
  castillaWhatsapp: "https://wa.link/mtvvhk",
};

// Local asset paths (downloaded from the original Wix site + Ariake brochure PDF)
export const IMG = {
  // Hero / company
  heroBg: "/projects/hero-bg.jpg",
  logoHH: "/projects/logo-hh.png",
  logoCVJ: "/projects/logo-cvj.png",
  // Featured project (Ariake — from brochure PDF)
  ariake: {
    cover1: "/ariake/ariake-1.jpg",
    cover2: "/ariake/ariake-2.jpg",
    cover3: "/ariake/ariake-3.jpg",
    cover4: "/ariake/ariake-4.jpg",
    sunrise: "/ariake/sunrise.jpg",
    entranceClean: "/ariake/entrance-clean.jpg",
    entrance1: "/ariake/entrance-1.jpg",
    entrance2: "/ariake/entrance-2.jpg",
    housesRow1: "/ariake/houses-row-1.jpg",
    housesRow2: "/ariake/houses-row-2.jpg",
    houseFeatures: "/ariake/house-features.jpg",
    interiorIntegrated: "/ariake/interior-integrated.jpg",
    interiorPorch: "/ariake/interior-porch.jpg",
    interiorSinGradas: "/ariake/interior-sin-gradas.jpg",
    kitchen: "/ariake/kitchen.jpg",
    garden: "/ariake/garden.jpg",
    porchePrivado: "/ariake/porche-privado.jpg",
    masterBath: "/ariake/master-bathroom.jpg",
    masterBed: "/ariake/master-bedroom.jpg",
    planA: "/ariake/plan-A.jpg",
    planA1: "/ariake/plan-A1.jpg",
    planB: "/ariake/plan-B.jpg",
    planB1: "/ariake/plan-B1.jpg",
    implantacion: "/ariake/implantacion.jpg",
    locationMap: "/ariake/location-map.jpg",
    amenityFirepit: "/ariake/amenity-firepit.jpg",
    amenityGreens: "/ariake/amenity-greens.jpg",
    amenityMirador: "/ariake/amenity-mirador.jpg",
    amenityPool: "/ariake/amenity-pool.jpg",
    plaza1: "/ariake/plaza-1.jpg",
    plazaClean: "/ariake/plaza-clean.jpg",
    plazaCafe: "/ariake/plaza-cafe.jpg",
  },
  // Castilla II — the most recent delivered project (Tumbaco)
  castilla2: "/projects/castilla2-hero.jpg",
  // Historical projects
  history: {
    "2002-solamar": "/projects/2002-solamar.jpg",
    "2002-quinara": "/projects/2002-quinara.jpg",
    "2004-belohorizonte1": "/projects/2004-belohorizonte1.jpg",
    "2005-belohorizonte2": "/projects/2005-belohorizonte2.jpg",
    "2007-altazor": "/projects/2007-altazor.jpg",
    "2008-bellini1": "/projects/2008-bellini1.jpg",
    "2008-bellini2": "/projects/2008-bellini2.jpg",
    "2009-vallegrande1": "/projects/2009-vallegrande1.jpg",
    "2010-vallegrande2": "/projects/2010-vallegrande2.jpg",
    "2011-vallegrande3": "/projects/2011-vallegrande3.jpg",
    "2012-vallegrande4": "/projects/2012-vallegrande4.jpg",
    "2014-campani1": "/projects/2014-campani1.jpg",
    "2015-campani2": "/projects/2015-campani2.jpg",
    "2016-caroba1": "/projects/2016-caroba1.jpg",
    "2017-caroba2": "/projects/2017-caroba2.jpg",
    "2018-caroba3": "/projects/2018-caroba3.jpg",
    "2019-caroba4": "/projects/2019-caroba4.jpg",
    "2020-stella": "/projects/2020-stella.png",
    "2021-castilla": "/projects/2021-castilla.jpg",
  },
};

export const ARIAKE = {
  name: "Ariake",
  slogan: "Tu hogar, un nuevo amanecer",
  status: "Disponible · 2026",
  concept:
    "Inspirado en el amanecer japonés, Ariake propone una experiencia de vida equilibrada y contemporánea, conectada con lo esencial: un lugar pensado para comenzar cada día con armonía.",
  longConcept:
    "Su privilegiado entorno natural, la cercanía al río Chiche y la calidad de su propuesta arquitectónica crean un espacio donde la luz, el paisaje y la calma se integran de forma natural. Una propuesta única que fusiona privacidad, comodidad, naturaleza y calidad de vida.",
  location: {
    label: "Tumbaco · Sector Hilacril",
    address: "Calle Río San Pedro, junto a Hilacril Plaza",
    city: "Tumbaco, Pichincha — Ecuador",
  },
  highlights: [
    { kpi: "130 — 140", unit: "m²", label: "Casas de una sola planta" },
    { kpi: "2.900+", unit: "m²", label: "Áreas verdes comunales" },
    { kpi: "2 y 3", unit: "dorm.", label: "Tipologías disponibles" },
    { kpi: "8", unit: "amenities", label: "Para toda la familia" },
  ],
  lifestyle: [
    { title: "Sin gradas, sin límites", body: "Casas de una sola planta con circulación fluida, libre y cómoda para todas las edades." },
    { title: "Ambientes integrados funcionalmente", body: "Área social conectada a una sala exterior cubierta, jardín y porche privado." },
    { title: "Moderna cocina con desayunador", body: "Diseño contemporáneo, texturas naturales y ventanales de gran formato." },
    { title: "Amplios jardines privados", body: "Desde 53 m² de jardín para cada casa. Tu propio espacio al aire libre." },
    { title: "Dormitorio máster con salida al jardín", body: "Walk-in closet, baño privado y conexión directa con la naturaleza." },
    { title: "Disfruta tu porche privado", body: "Espacios cubiertos para vivir el exterior cualquier día del año." },
  ],
  amenities: [
    { name: "Piscina", icon: "waves" },
    { name: "Gimnasio", icon: "dumbbell" },
    { name: "Mirador 360°", icon: "mountain" },
    { name: "Fire Pit", icon: "flame" },
    { name: "Yoga Park", icon: "flower-2" },
    { name: "Kids Place", icon: "baby" },
    { name: "Área de BBQ", icon: "utensils" },
    { name: "Pet Park", icon: "paw-print" },
  ],
  typologies: [
    {
      id: "A", name: "Casa Tipo A", area: "130 m²", beds: "3 dormitorios", baths: "2.5 baños",
      garden: "Jardín privado desde 53 m²",
      plan: IMG.ariake.planA,
      hero: IMG.ariake.housesRow1,
      detail: [
        "Dormitorio máster con walk-in closet",
        "2 dormitorios secundarios",
        "Cocina con desayunador",
        "Porche cubierto 16,39 m²",
        "2 parqueaderos (1 cubierto · 1 semicubierto)",
        "Área total cubierta 130,70 m²",
      ],
    },
    {
      id: "A1", name: "Casa Tipo A1", area: "130 m²", beds: "2 dorm. + sala", baths: "2.5 baños",
      garden: "Jardín privado desde 53 m²",
      plan: IMG.ariake.planA1,
      hero: IMG.ariake.interiorIntegrated,
      detail: [
        "Máster con walk-in closet",
        "Dormitorio #2 con walk-in closet",
        "Sala de estar adicional",
        "Cocina con desayunador",
        "Porche cubierto 16,39 m²",
        "2 parqueaderos (1 cubierto · 1 semicubierto)",
      ],
    },
    {
      id: "B", name: "Casa Tipo B", area: "140 m²", beds: "3 dormitorios", baths: "2.5 baños",
      garden: "Jardín privado desde 55 m²",
      plan: IMG.ariake.planB,
      hero: IMG.ariake.housesRow2,
      detail: [
        "Dormitorio máster con walk-in closet",
        "2 dormitorios secundarios",
        "Cocina con desayunador",
        "Porche cubierto 16,39 m²",
        "2 parqueaderos (1 cubierto · 1 semicubierto)",
        "Área total cubierta 140,27 m²",
      ],
    },
    {
      id: "B1", name: "Casa Tipo B1", area: "140 m²", beds: "2 dorm. + sala", baths: "2.5 baños",
      garden: "Jardín privado desde 53 m²",
      plan: IMG.ariake.planB1,
      hero: IMG.ariake.masterBed,
      detail: [
        "Máster con walk-in closet",
        "Dormitorio #2 con walk-in closet",
        "Sala de estar adicional",
        "Cocina con desayunador",
        "Porche cubierto 16,39 m²",
        "2 parqueaderos (1 cubierto · 1 semicubierto)",
      ],
    },
  ],
  plaza: {
    title: "Plaza Comercial Ariake",
    desc: "Un espacio que transforma tu estilo de vida. Tener lo esencial a pasos de casa.",
    stats: [
      { value: "8", label: "Locales", suffix: "" },
      { value: "75 — 91", label: "m² por local", suffix: "" },
      { value: "20", label: "Estacionamientos de visita", suffix: "" },
    ],
  },
  images: IMG.ariake,
};

// Castilla II — most recent delivered, kept as in the original site
export const CASTILLA2 = {
  name: "Conjunto Castilla 2",
  status: "Entregado · 2024",
  location: "Sector Tumbaco",
  image: IMG.castilla2,
  whatsapp: SITE.castillaWhatsapp,
  brochure: SITE.castillaBrochureUrl,
  features: [
    "Casas esquineras",
    "Amplios patios privados",
    "Dos plantas",
    "3 dormitorios",
    "2 baños y medio",
    "Estudio o sala de estar",
    "Área comunal",
  ],
};

// Full delivered portfolio (from current site)
export const HISTORY = [
  { year: "2002", name: "Edificio Solamar", image: IMG.history["2002-solamar"] },
  { year: "2002", name: "Edificio Quinara", image: IMG.history["2002-quinara"] },
  { year: "2004", name: "Belohorizonte 1", image: IMG.history["2004-belohorizonte1"] },
  { year: "2005", name: "Belohorizonte 2", image: IMG.history["2005-belohorizonte2"] },
  { year: "2007", name: "Edificio Altazor", image: IMG.history["2007-altazor"] },
  { year: "2008", name: "Edificio Bellini 1", image: IMG.history["2008-bellini1"] },
  { year: "2008", name: "Bellini 2", image: IMG.history["2008-bellini2"] },
  { year: "2009", name: "Conjunto Valle Grande 1", image: IMG.history["2009-vallegrande1"] },
  { year: "2010", name: "Conjunto Valle Grande 2", image: IMG.history["2010-vallegrande2"] },
  { year: "2011", name: "Conjunto Valle Grande 3", image: IMG.history["2011-vallegrande3"] },
  { year: "2012", name: "Conjunto Valle Grande 4", image: IMG.history["2012-vallegrande4"] },
  { year: "2013", name: "Conjunto Rafaela", image: IMG.history["2002-quinara"] },
  { year: "2014", name: "Conjunto Campani 1", image: IMG.history["2014-campani1"] },
  { year: "2015", name: "Conjunto Campani 2", image: IMG.history["2015-campani2"] },
  { year: "2016", name: "Conjunto Caroba 1", image: IMG.history["2016-caroba1"] },
  { year: "2017", name: "Conjunto Caroba 2", image: IMG.history["2017-caroba2"] },
  { year: "2018", name: "Conjunto Caroba 3", image: IMG.history["2018-caroba3"] },
  { year: "2019", name: "Conjunto Caroba 4", image: IMG.history["2019-caroba4"] },
  { year: "2020", name: "Conjunto Stella", image: IMG.history["2020-stella"] },
  { year: "2021", name: "Conjunto Castilla", image: IMG.history["2021-castilla"] },
];

export const PROCESS = [
  { step: "01", title: "Conoce nuestros proyectos", body: "Haz un recorrido por nuestros proyectos disponibles y conoce su propuesta." },
  { step: "02", title: "Descarga el brochure", body: "Recibe el material comercial completo con tipologías, planos y amenities." },
  { step: "03", title: "Contacta a nuestros agentes", body: "Conversa con un asesor Savana y resuelve cada detalle." },
  { step: "04", title: "Reserva tu próximo hogar", body: "Reserva con tan solo el 5% tu futuro hogar." },
  { step: "05", title: "Te acompañamos", body: "Asesoría personalizada durante todo el proceso hasta la entrega de llaves." },
];
